/**
 * Ikonkalar.
 *
 * Kutubxona qo'shilmadi: kerak bo'lgan ~20 ta belgi uchun 200 KB
 * paket olib kelish o'zini oqlamaydi va Electron bundle'ini
 * kattalashtirardi. Barchasi bir xil 24×24 panjarada, 1.75
 * qalinlikda — Material Symbols "outlined" uslubiga yaqin.
 */
import type { SVGProps } from "react";

const PATHS = {
  dashboard: "M4 13h6V4H4v9Zm0 7h6v-5H4v5Zm10 0h6v-9h-6v9Zm0-16v5h6V4h-6Z",
  topology: "M4 6h7v5H4V6Zm9 0h7v5h-7V6ZM4 13h7v5H4v-5Zm9 0h7v5h-7v-5Z",
  stock: "M3 7l9-4 9 4v10l-9 4-9-4V7Zm9 2l6-2.7M12 9v11M12 9L6 6.3",
  task: "M9 5h6M9 12h6M9 19h6M4.5 5h.01M4.5 12h.01M4.5 19h.01",
  // Sudrash dastagi: olti nuqta. Qalin chiziq o'rniga nuqtalar —
  // dastak qatordagi matndan ajralib turishi, lekin uni bosib
  // ketmasligi kerak.
  grip: "M9 6h.01M15 6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01",
  // Qulf: ko'chirib bo'lmaydigan qator.
  lock: "M7 11V8a5 5 0 0 1 10 0v3M5 11h14v10H5V11Z",
  block: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM5.6 5.6l12.8 12.8",
  discrepancy: "M12 4 2.5 20h19L12 4Zm0 6v5m0 3h.01",
  count: "M5 4h14v16H5V4Zm3 4h8M8 12h8M8 16h5",
  report: "M4 20V9m5 11V4m5 16v-7m5 7V7",
  integration: "M8 7H6a4 4 0 0 0 0 8h2m8 0h2a4 4 0 0 0 0-8h-2M9 11h6",
  bell: "M12 4a5 5 0 0 0-5 5v3l-2 3h14l-2-3V9a5 5 0 0 0-5-5Zm-2 14a2 2 0 0 0 4 0",
  settings:
    "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm8.5 3a8.5 8.5 0 0 0-.1-1.2l2-1.5-2-3.4-2.3 1a8.4 8.4 0 0 0-2.1-1.2L15.6 2h-3.9l-.4 2.7a8.4 8.4 0 0 0-2.1 1.2l-2.3-1-2 3.4 2 1.5a8.6 8.6 0 0 0 0 2.4l-2 1.5 2 3.4 2.3-1a8.4 8.4 0 0 0 2.1 1.2l.4 2.7h3.9l.4-2.7a8.4 8.4 0 0 0 2.1-1.2l2.3 1 2-3.4-2-1.5c.06-.4.1-.8.1-1.2Z",
  shield: "M12 3 4.5 6v6c0 4.5 3.2 8 7.5 9 4.3-1 7.5-4.5 7.5-9V6L12 3Z",
  audit: "M6 3h9l4 4v14H6V3Zm9 0v4h4M9 12h6M9 16h4",
  media: "M4 5h16v14H4V5Zm3 10 3-3 3 3 2-2 3 3M9 9h.01",
  // Qobiq relsi: bosh sahifa va foydalanuvchi bloki.
  home: "M4 10.5 12 4l8 6.5V20h-5.5v-6h-5v6H4v-9.5Z",
  chevronUpDown: "M8 9l4-4 4 4M8 15l4 4 4-4",
  arrowUp: "M12 19V5m0 0-6 6m6-6 6 6",
  arrowDown: "M12 5v14m0 0-6-6m6 6 6-6",
  // Zaxira: bulutga yuklash (serverdan tashqari nusxa).
  backup: "M7 18a4 4 0 0 1-.4-8 6 6 0 0 1 11.5 1.3A3.5 3.5 0 0 1 17.5 18H13m-1-7v10m0-10-3 3m3-3 3 3",
  search: "M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm5 12 4 4",
  refresh: "M20 11a8 8 0 1 0-.6 4M20 5v6h-6",
  close: "M6 6l12 12M18 6 6 18",
  check: "M5 13l4 4L19 7",
  chevronLeft: "M15 6l-6 6 6 6",
  chevronRight: "M9 6l6 6-6 6",
  chevronDown: "M6 9l6 6 6-6",
  alert: "M12 4 2.5 20h19L12 4Zm0 6v5m0 3h.01",
  logout: "M15 4h4v16h-4M11 8l-4 4 4 4M7 12h9",
  sun: "M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0-5v2m0 20v-2M4.2 4.2l1.4 1.4m12.8 12.8 1.4 1.4M2 12h2m18 0h-2M4.2 19.8l1.4-1.4M17 5.6l1.4-1.4",
  moon: "M20 14a8.5 8.5 0 0 1-10-10 8.5 8.5 0 1 0 10 10Z",
  warehouse: "M3 20V8l9-4 9 4v12M8 20v-7h8v7",
  filter: "M4 5h16l-6 7v6l-4 2v-8L4 5Z",
  external: "M14 4h6v6M20 4l-8 8M18 14v5H5V6h5",
  map: "M3 6.5 9 4l6 2.5L21 4v13.5L15 20l-6-2.5L3 20V6.5Zm6-2.5v13.5m6-11V20",
  layers: "M12 3.5 3 8l9 4.5L21 8l-9-4.5ZM3 12.5 12 17l9-4.5M3 17l9 4.5 9-4.5",
  pallet: "M4 5h7v6H4V5Zm9 0h7v6h-7V5ZM4 11h16M3 15h18M5 15v4M12 15v4M19 15v4",
  plus: "M12 5v14M5 12h14",
  minus: "M5 12h14",
  sidebar: "M4 5h16v14H4V5Zm5.5 0v14",
  printer: "M7 9V4h10v5M7 18H5v-6h14v6h-2M7 14h10v6H7v-6Z",
  download: "M12 4v11m0 0-4-4m4 4 4-4M5 19h14",
  scan: "M4 8V5h3m10 0h3v3M20 16v3h-3M7 19H4v-3M4 12h16",
  target: "M12 3v3m0 12v3M3 12h3m12 0h3M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z",
} as const;

export type IconName = keyof typeof PATHS;

interface IconProps extends Omit<SVGProps<SVGSVGElement>, "name"> {
  name: IconName;
  size?: number;
}

export function Icon({ name, size = 20, ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
